import UsersPermissionsContainer from "../../../features/user/UsersPermissionsContainer";
import { hasPermission, PermissionId, SCHOOL_PERMISSIONS } from "../../../app/permissions";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";

interface SchoolUsersListProps {
  schoolId: string;
}

const SchoolUsersList = ({ schoolId }: SchoolUsersListProps) => {
    const user = useSelector(selectUser);
    return <UsersPermissionsContainer
        canGrantPermission={hasPermission(user.priza.info, PermissionId.SCHOOL_ADMIN, schoolId)}
        targetId={schoolId}
        permissions={SCHOOL_PERMISSIONS}
        messages={{
        title: "Permissões",
        empty: "Ninguém associado a esta escola.",
        }}
    />;
};

export default SchoolUsersList;